var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLink = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 2.00008H2.00002C1.26364 2.00008 0.666687 2.59703 0.666687 3.33341L0.666687 10.0001C0.666687 10.7365 1.26364 11.3334 2.00002 11.3334H8.66669C9.40307 11.3334 10 10.7365 10 10.0001V7.33341M7.33335 0.666748L11.3334 0.666748M11.3334 0.666748V4.66675M11.3334 0.666748L4.66669 7.33341",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/link.86f172b6.svg";
export { ForwardRef as ReactComponent };